module.exports = __webpack_public_path__ + "img/w_google.e985a0a4.svg";